import React from "react";

import { useIntl } from "react-intl";

import MetricName from "src/organization/pages/project/environment/metrics/containers/Service/Metric/MetricName";

import { ChartTitle } from "../styles";

import {
  TitleHeaderContainer,
  TotalChartList,
  TotalSkeletonContainer,
  TotalUnitSkeleton
} from "./style";

const usageSkeletonUnits = ["CPU", "RAM", "Disk"];

const UsageViewSkeleton = () => {
  const intl = useIntl();

  return (
    <TotalSkeletonContainer>
      <TitleHeaderContainer>
        <ChartTitle>
          {intl.formatMessage({
            id: "total_usage"
          })}
        </ChartTitle>
      </TitleHeaderContainer>
      <TotalChartList className="total-unit-list">
        {usageSkeletonUnits.map(n => (
          <React.Fragment key={n}>
            <TotalUnitSkeleton
              name={<MetricName name={n} kind={n} serviceKind={n} />}
            />
            {n != usageSkeletonUnits[2] && <hr className="divider" />}
          </React.Fragment>
        ))}
      </TotalChartList>
    </TotalSkeletonContainer>
  );
};

export default UsageViewSkeleton;
